import React, { Profiler } from "react";
import { useParams } from "react-router-dom";
import { AppShellDesktop } from "../components/elements/AppShell/index.js";
import ConfirmationInnerLoader from "../components/elements/ConfirmationInnerLoader/index.js";
import Container from "../components/elements/Container/index.js";
import { assert } from "../utils/assert.js";
import { PageHeader } from "./Home.js";
import useClientMetrics from "../hooks/useClientMetrics.js";
import { WebCheckinInner } from "../components/elements/WebCheckinInner/index.js";
import styles from "./WebCheckin.desktop.module.css";
import NoSSR from "../app/NoSSR/index.js";
function Webcheckin() {
    const params = useParams();
    const { trackRenderTime } = useClientMetrics();
    assert(params?.orderToken, "Missing orderToken parameter");
    return (React.createElement(Profiler, { id: "screen", onRender: trackRenderTime },
        React.createElement(PageHeader, null),
        React.createElement(AppShellDesktop, { className: styles.appShell },
            React.createElement(NoSSR, null,
                React.createElement(Container, { pr: 4, pl: 4 },
                    React.createElement(ConfirmationInnerLoader, { token: params?.orderToken, cache: true },
                        React.createElement(WebCheckinInner, null)))))));
}
export default Webcheckin;
